// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3nqv9","insightsList":"newBusinessInsightsMenu_insightsList__3kiIn","active":"newBusinessInsightsMenu_active__3ZCNq"};